// src/auth/authSelectors.js

// The base selector to get the auth slice
const selectAuth = (state) => state.auth;

// 💡 Centralized accessor for the user object
export const selectUser = (state) => selectAuth(state).user;

export const selectToken = (state) => selectAuth(state).access_token;
// Selector to check if the user is authenticated
export const selectIsAuthenticated = (state) => selectAuth(state).isAuthenticated;

// Selector to derive the user's default dashboard path based on their role (group_id)
export const selectUserDashboardPath = (state) => {
  const user = selectAuth(state).user;
  // This uses the same logic as getDefaultRouteByRole but encapsulated in Redux selector
  if (!user || !user.group_id) return '/dashboard'; 
  
  switch (user.group_id) {
    case 1:
      return '/admin/dashboard';
    case 2:
      return '/coach/dashboard';
    case 3:
      return '/student/dashboard';
    default:
      return '/';
  }
};

export const isLoggedInAndRestrictedPublic = (state) => {
  const user = selectAuth(state).user;

  if (!user) return false; // guest → allowed to access public

  // ❌ Admin, Coach, Student cannot access public routes
  if ([1, 2, 3].includes(user.group_id)) return true;

  // ✅ Public user (group_id = 4) can access public pages
  return false;
};
